import React from 'react';

import getCommonStack, { CommonStackParamList } from '@navigation/CommonStack';
import { FollowUsersRoute } from '@navigation/Routes';
import { createStackNavigator } from '@react-navigation/stack';
import FollowUsersScreen from '@screens/User/FollowUsers';

export type FollowUsersScreenType = 'tab' | 'onboarding';

export type FollowUsersStackParamList = {
  [FollowUsersRoute.FollowUsers]: {
    screenType?: FollowUsersScreenType;
  };
} & CommonStackParamList;

const FollowUsersStackNavigator = createStackNavigator<FollowUsersStackParamList>();

export default function FollowUsersStack() {
  return (
    <FollowUsersStackNavigator.Navigator
      id={undefined}
      initialRouteName={FollowUsersRoute.FollowUsers}
      screenOptions={{
        headerShown: true,
        headerBackButtonDisplayMode: 'generic',
      }}>
      <FollowUsersStackNavigator.Screen
        name={FollowUsersRoute.FollowUsers}
        component={FollowUsersScreen}
        initialParams={{ screenType: 'tab' }}
        options={{ title: 'People' }}
      />
      {getCommonStack(FollowUsersStackNavigator)}
    </FollowUsersStackNavigator.Navigator>
  );
}
